import ItemRow from './TbbItemRow';
import style from './TbbItemList.module.scss';

const { container } = style;
const ItemList = ({ dataList, setTbbData }) => (
  <div className={container}>
    {dataList.map((itemData) => (
      <ItemRow key={itemData.uid} itemData={itemData} setTbbData={setTbbData} />
    ))}
  </div>
);

export default ItemList;
